import React, { useEffect, useState, useRef } from 'react';
interface AnimateOnScrollProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function AnimateOnScroll({
  children,
  delay = 0,
  className = ''
}: AnimateOnScrollProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.unobserve(el);
      }
    }, {
      threshold: 0.15
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`scroll-animate ${visible ? 'visible' : ''} ${className}`} style={{
    animationDelay: visible ? `${delay}s` : undefined
  }} data-id="element-10">
      {children}
    </div>;
}